import useAPIMutation from '../api/useAPIMutation';

function useSetLanguageCookie(language?: string) {
  const { mutateAsync: changeLggBackend } = useAPIMutation(async (language: string, api) => {
    const response = await api.post('/configs/set-language-code/', {
      language_code: language,
    });

    return response.data;
  });

  return { changeLggBackend };
}
export default useSetLanguageCookie;
